import _ from 'lodash';
import utils from 'lib/utils';
import config from 'config';
import store from 'redux/store';

export const reqTransform = {
  fetchList(params) {
    let bodyParams = {
      ...params,
      invoking_Person_Id: _.get(window, 'user.userid') || 0, // 585
      // offset: 0,
      // page_size: 100,
    };
    return bodyParams;
  },
  recordPaymentByBuyerSeller(params) {
    return params;
  },
  fetchDetails(id) {
    return id;
  },
  // create(params = {}) {
  //   let bodyParams = {
  //     ...params,
  //     person_id: params['person_id'] || _.get(window, 'user.userid', 0),
  //     operation_Enum: 1,
  //     company_id: _.get(window, 'user.profile.person.company_id', 0),
  //     affiliate_code: params['affiliate_name'] || '',
  //   };
  //   return bodyParams;
  // },
  update(id, params) {
    let bodyParams = {
      commodity_deal_master_id: parseInt(id),
      invoking_person_id: _.get(window, 'user.userid', 0),
      is_saved_as_draft: true,
      bf_transport_delivery_schedule: [],
    };

    bodyParams['bf_transport_delivery_schedule'] = (params.schedule || []).map((item) => {
      return {
        transport_delivery_schedule_id: item.transport_delivery_schedule_id,
        proposed_delivery_qty: item.total_quantity,
      };
    });

    return bodyParams;
  },

  confirm(id, params) {
    let bodyParams = {
      commodity_deal_master_id: parseInt(id),
      invoking_person_id: _.get(window, 'user.userid', 0),
      is_saved_as_draft: false,
      bf_transport_delivery_schedule: [],
    };

    bodyParams['bf_transport_delivery_schedule'] = (params.schedule || []).map((item) => {
      return {
        transport_delivery_schedule_id: item.transport_delivery_schedule_id,
        proposed_delivery_qty: item.total_quantity,
      };
    });

    return bodyParams;
  },
  // destroy(id) {
  //   return id;
  // },
};

export const resTransform = {
  fetchList(resData) {
    let scheduleData = (_.isArray(resData) ? resData : []).map((details) => {
      return resTransform.fetchDetails(details);
    });
    return _.keyBy(scheduleData, 'invoice_master_id');
  },
  recordPaymentByBuyerSeller(resData) {
    let data = {
      ...resData,
      id: _.get(resData, 'payment_master.payment_master_id'),
    };
    return data;
  },
  fetchDetails(resData) {
    return {
      ...resData,
      id: _.get(resData, 'invoice_master_id') || 0,
      amount_to_pay: _.get(resData, 'payable') || 0,
    };
  },
  create(resData) {
    return resData;
    // return resTransform.fetchDetails(details);
  },
  update(resData) {
    return resData;
    // return resTransform.fetchDetails(details);
  },
  destroy(resData) {
    return resData;
    // return res;
  },
};
